import { put, takeLatest } from "redux-saga/effects";
import { requestdueDetailsAndDueDetailsBreakupReportsList, requestSdDueDetailsReportsList } from "services/acclgl/reports/dueDetailsAndBreakupReport";
import {
  fetchDueDetailsReportsListRequest,
  fetchDueDetailsReportsListSuccess,
  fetchDueDetailsReportsListFailure,
  fetchSDDueDetailsReportsListRequest,
  fetchSDDueDetailsReportsListSuccess,
  fetchSDDueDetailsReportsListFailure,
} from "../../../reducers/acclgl/reports/deuDetailsReports";
export function* watchDueDetailsReportsSaga() {
  yield takeLatest(fetchDueDetailsReportsListRequest, fetchDueDetailsReportsList);
  yield takeLatest(fetchSDDueDetailsReportsListRequest, fetchSDDueDetailsReportsList);
}

function* fetchDueDetailsReportsList({ payload }) {
  try {
    const response = yield requestdueDetailsAndDueDetailsBreakupReportsList(payload);
    yield put(fetchDueDetailsReportsListSuccess(response));
  } catch (error) {
    yield put(
        fetchDueDetailsReportsListFailure("Failed to get list of due details reports")
    );
  }
}

function* fetchSDDueDetailsReportsList({ payload }) {
  try {
    const response = yield requestSdDueDetailsReportsList(payload);
    yield put(fetchSDDueDetailsReportsListSuccess(response));
  } catch (error) {
    yield put(
        fetchSDDueDetailsReportsListFailure("Failed to get list of SD due details")
    );
  }
}
